import { LineChart } from "../../components";
import PainCard from "../../components/pain-card/pain-card";
import PerformanceTable from "../../components/performance-table/performance-tables";

export default function ZM_UI({data}) {
 
    return (
        <>
            <div className="cards">
            <div className="card">
                    <h2>29.4</h2>
                    <p className="title">Average Patient Registration (Monthly)</p>
                    <p className="target">Monthly Target: 31.5</p>
                    {/* Placeholder for chart */}
                    <div><LineChart data={data?.monthlyUsersCount} /></div>
                </div>

                <div style={{ display: "flex", gap: "16px" }}>
                    <PainCard
                        title="Average Patient Registration (Pain Classified) (Monthly)"
                        pain1={data?.zmPainAvg?.pain1Avg}
                        pain2={data?.zmPainAvg?.pain2Avg}
                        overall={data?.zmPainAvg?.overAllPainAvg}
                        target={11.0}
                    />
                </div>
                <div style={{ display: "flex", gap: "16px" }}>

                    <PainCard
                        title="Average Patient Registration (Pain Classified) (Monthly)"
                        pain1={data?.rmPainAvg?.pain1Avg}
                        pain2={data?.rmPainAvg?.pain2Avg}
                        overall={data?.rmPainAvg?.overAllPainAvg}
                        target={11.0}
                    />
                </div>
            </div>

          <PerformanceTable data={data?.results} />
          <div style={{height:"200px"}}></div>
        </>
    )

}